import {
  startTransition,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { SpaceObjectType } from "../../types";
import * as THREE from "three";
import { getPositionFromSatrec } from "../../utils/index";

import { ThreeEvent, useFrame, useThree } from "@react-three/fiber";
import { useInteractObjectStore } from "@graphic/stores/graphic/interact-object-store";
import { RENDER_ORDER } from "@graphic/constants";
import { useTimeStore } from "@graphic/stores";
import useSpaceObject from "./use-space-object";

const center = new THREE.Vector3(0, 0, 0);

export const useObjectGroup = (data: SpaceObjectType) => {
  const groupRef = useRef<THREE.Group | null>(null);
  const meshRef = useRef<THREE.Mesh | null>(null);

  const { object } = useSpaceObject({ data, ref: groupRef });

  const { focus, setFocus } = useInteractObjectStore(state => ({
    focus: state.focus,
    setFocus: state.setFocus
  }));

  const matrix4 = new THREE.Matrix4();
  const matrix3 = new THREE.Matrix3();
  const quarternion = new THREE.Quaternion(1, 0, 0, 0);
  const vectors = Array.from({ length: 3 }).map(() => new THREE.Vector3());

  useEffect(() => {
    if (!groupRef.current || !meshRef.current) return;
    if (!object) return;
    groupRef.current.add(meshRef.current);
  }, [groupRef, meshRef]);

  useFrame(({ camera }, delta) => {
    if (!groupRef.current) return;
    if (!object) return;

    const time = useTimeStore.getState().time;
    updateGroupPosition(object, time);
  }, RENDER_ORDER.OBJECT);

  // useFrame(({ camera }) => {}, RENDER_ORDER.OBJECT);

  // const setObjects = (objects: SpaceObject[], uuid: string, subtype: SubTypeValue) => {
  //   addObjects(objects, uuid, subtype);
  // };

  const handleClick = useCallback(
    (e: ThreeEvent<MouseEvent>) => {
      e.stopPropagation();

      // const id = e.instanceId;

      // if (id === undefined) return;

      // const object = objects[id];
      // if (!object) return;

      const { noradId } = object;
      const { uuid } = groupRef.current;

      startTransition(() => {
        if (focus.object && focus.object.noradId === noradId) {
          setTimeout(() => setFocus(null));
          return;
        }

        setTimeout(() =>
          setFocus({
            ...object,
            uuid
          })
        );
      });
    },
    [object, focus, groupRef.current]
  );

  const handlePointerOver = useCallback(
    (e: ThreeEvent<PointerEvent>) => {
      e.stopPropagation();
      // if (!groupRef.current) return;
      // if (groupRef.current.visible === false) return;

      // const id = e.instanceId;
      // if (id === undefined) return;

      // const object = objects[id];
      // if (!object) return;

      // const { uuid } = groupRef.current;

      globalThis.document.body.style.cursor = "pointer";

      // setHover({
      //   ...object,
      //   uuid,
      //   instanceId: id
      // });
    },
    [object, groupRef.current]
  );

  const handlePointerLeave = useCallback((e: ThreeEvent<PointerEvent>) => {
    e.stopPropagation();
    globalThis.document.body.style.cursor = "auto";
    // startTransition(() => setHover(null));
  }, []);

  const updateGroupPosition = (object: SpaceObjectType, time: Dayjs) => {
    const { satrec } = object;
    // matrix.makeScale(15,15,15);

    const position = getPositionFromSatrec(satrec, time);

    if (!position) return;

    const { x, y, z } = position;

    if (!groupRef.current) return;

    groupRef.current.position.set(x, y, z);
    groupRef.current.lookAt(center);
  };

  const getPosition = () => {
    if (!groupRef.current) return new THREE.Vector3();

    return groupRef.current.position;
  };

  return {
    groupRef,
    meshRef,
    handlePointerOver,
    handlePointerLeave,
    handleClick,
    getPosition
  };
};
